import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Button } from 'react-bootstrap'
import closeDialogImg from '../images/close-dialog-x.png'

/**
 * A basic component that provides functionality for a "soft link" in text that
 * when clicked will display a pop up box with text. The idea is to let the
 * user drill down to more information on some topic without actually
 * navigating to another page.
 */
export default class PopOver extends Component {
  /**
   * c'tor
   */
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.closeClick = this.closeClick.bind(this)
    this.state = { expanded: false }
  }

  /**
   * Event handler for when the user clicks on the soft-link
   */
  handleClick () {
    this.setState({ expanded: true })
  }

  /**
   * Event handler for closing the pop up box
   */
  closeClick () {
    this.setState({ expanded: false })
  }

  /**
   * Render the component
   */
  render () {
    const linkTextStyle = {
      cursor: 'pointer',
      color: '#7B3F00',
      borderBottom: '2px dotted #7B3F00'
    }

    const boxContainerStyle = {
      position: 'absolute',
      zIndex: 100
    }

    const boxStyle = {
      backgroundColor: '#D7D6D6',
      opacity: '0.96',
      padding: 20,
      width: 'auto',
      height: 'auto',
      borderStyle: 'solid',
      borderWidth: 3,
      borderRadius: 10,
      borderColor: '#00B084'
    }

    const closeXStyle = {
      float: 'right',
      cursor: 'pointer',
      paddingBottom: 20,
      paddingLeft: 20
    }

    // if expanded, display the pop up box
    if (this.state.expanded) {
      return (
        <span>
          <span style={linkTextStyle} onClick={this.handleClick}>
            {this.props.linkText}
          </span>
          <div style={boxContainerStyle}>
            <Col xs={0} sm={1} />
            <Col xs={12} sm={10} md={8}>
              <div style={boxStyle}>
                <div>
                  <img
                    style={closeXStyle}
                    src={closeDialogImg}
                    alt='Close Popover'
                    onClick={this.closeClick}
                  />
                </div>
                {this.props.children}
                <div>
                  <Button
                    className='btn btn-secondary'
                    onClick={this.closeClick}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </Col>
            <Col xs={0} sm={1} md={3} />
          </div>
        </span>
      )
    } else {
      // if not expanded, just display the link text
      return (
        <span style={linkTextStyle} onClick={this.handleClick}>
          {this.props.linkText}
        </span>
      )
    }
  }
}

PopOver.propTypes = {
  linkText: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/sections/PopOver.js